import React from 'react';
import { TableColGroup } from './TableColGroup';
import TableSections from './TableSections';
import TableTitles from './TableTitles';
import TableFilters from './TableFilters';
import { ActionsFeature, TblCol, TblSection, TblSort, TblSortDir } from './table.types';

type TblHeadProps = {
    cols: TblCol[];
    actions?: ActionsFeature[];
    sections?: TblSection[] | undefined;
    sort?: TblSort | undefined;
    filters: object | undefined;
    setFilter: (key: string, val: any) => void;
    setSort?: (col: string, dir?: TblSortDir | undefined) => void | undefined;
};

const TableHead = ({ cols, actions, sections, sort, setSort, filters, setFilter }: TblHeadProps): JSX.Element => {
    return (
        <>
            <TableColGroup cols={cols} />
            <thead>
                <TableSections
                    actions={actions}
                    sections={sections}
                />
                <TableTitles
                    actions={actions}
                    cols={cols}
                    sort={sort}
                    onSort={setSort}
                />
                <TableFilters
                    actions={actions}
                    cols={cols}
                    filters={filters}
                    onFilter={setFilter}
                />
            </thead>
        </>
    );
};

export default React.memo(TableHead);
